module.exports = __webpack_public_path__ + "static/media/solbrain06.c2fe7ce4.jpg";